import { useEffect, useState } from "react";
import around_colage from "../../images/Projects/around_colage.png";
import beled_colage from "../../images/Projects/beled1.png";
import laundry_colage from "../../images/Projects/laundry1.png";
import news_colage from "../../images/Projects/news_colage.png";
import pokedex_colage from "../../images/Projects/pokedex_colage.PNG";
import ptt_colage from "../../images/Projects/ptt_canvas.png";
import ImageSlider from "../ImageSlider/ImageSlider";
import "./Projects.css";

import News1 from "../../images/Projects/news1.png";
import News2 from "../../images/Projects/news2.png";
import News3 from "../../images/Projects/news3.png";
import News4 from "../../images/Projects/news4.png";
import News5 from "../../images/Projects/news5.png";
import NewsCanvas from "../../images/Projects/news_colage.png";

import Around1 from "../../images/Projects/around1.png";
import Around2 from "../../images/Projects/around2.png";
import Around3 from "../../images/Projects/around3.png";
import Around4 from "../../images/Projects/around4.png";
import Around5 from "../../images/Projects/around5.png";
import Around6 from "../../images/Projects/around6.png";
import AroundCanvas from "../../images/Projects/around_colage.png";

import Poke1 from "../../images/Projects/Pokedex1.png";
import Poke2 from "../../images/Projects/Pokedex2.png";
import Poke3 from "../../images/Projects/Pokedex3.png";
import Poke4 from "../../images/Projects/Pokedex4.png";
import PokedexCanvas from "../../images/Projects/pokedex_colage.PNG";

import Ptt1 from "../../images/Projects/ptt1.jpg";
import Ptt2 from "../../images/Projects/ptt2.png";
import Ptt3 from "../../images/Projects/ptt3.png";
import PttCanvas from "../../images/Projects/ptt_canvas.png";

export default function Projects() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [description, setDescription] = useState([]);

  useEffect(() => {
    if (!isPopupOpen) {
      setSlides([]);
      setTitle("");
      setSubtitle("");
      setDescription([]);
    }
  }, [isPopupOpen]);

  const openPopup = (index) => {
    switch (index) {
      case 1:
        setSlides([beled_colage]);
        setTitle("Beled");
        setSubtitle(
          "Your trusted trading partner, simplifying sourcing and delivering success."
        );
        setDescription([
          "• The client had an existing website and wanted to redesign it since the website was overloaded with text and irrelevant information.",
          "• I entered the client's website and did research on his company, what it does and who its target audience is.",
          "• I filtered out the information that was not relevant and made adjustments to the text so that it would be short, catchy and professional.",
          "• I built a website from scratch and entered all the relevant information, I made sure that the website is light, not overloaded with information and easy to navigate.",
          "• I entered keywords so that the search engine could find the site easily and thus saved the client money in promoting the site.",
          "• Two days after the website was completed and published, the website has over 60 hits per day!",
        ]);
        break;

      case 2:
        setSlides([laundry_colage]);
        setTitle("Hasharon-laundry");
        setSubtitle("Self-service laundry services.");
        setDescription([
          "• The client asked me to build him a website so that he could advertise on the social media.",
          "• The client asked for a simple and clean design, the site should be responsive to fit smart phones as well.",
          "• I built the site from scratch and inserted images and text that would suit the business.",
          "• I purchased a domain for the client and published the site.",
          "• I entered keywords so that the search engine could find the site easily and thus saved the client money in promoting the site.",
          "• The client was very satisfied with the website and published it on the social media.",
          "• After about two weeks, the amount of exposure of the website increased and new customers started coming to the business.",
        ]);
        break;

      case 3:
        setSlides([NewsCanvas, News1, News2, News3, News4, News5]);
        setTitle("News‑explorer");
        setSubtitle("Search and reveal the latest worldwide news.");
        setDescription([
          "• Created a news search engine using React according to a Figma design for the Front‑end and NodeJS, Express and MongoDB for the Back‑end.",
          "• This project makes use of a free third party NewsAPI which collects all the latest articles on the web and let the developer make use of them.",
          "• In this project, users are able to search for articles by typing keyword and reveal the latest news, registered users can save or delete articles.",
        ]);
        break;

      case 4:
        setSlides([
          AroundCanvas,
          Around1,
          Around2,
          Around3,
          Around4,
          Around5,
          Around6,
        ]);
        setTitle("Around The U.S");
        setSubtitle("A social photos sharing website.");
        setDescription([
          "• Created a social photos sharing platform using React according to a Figma design for the Front‑end and NodeJS, Express and MongoDB for the Back‑end.",
          "• Make use of Router‑v6 to protect Routes from users that aren’t logged in, Authentication and authorization handled by the Back‑end, using JWT.",
          "• In this project, users are able to create their own profile, upload or delete their own photos, and like or dislike others photos.",
        ]);
        break;

      case 5:
        setSlides([PokedexCanvas, Poke1, Poke2, Poke3, Poke4]);
        setTitle("Pokedex");
        setSubtitle("Explore and learn about variant of Pokemons.");
        setDescription([
          "• Once opening the web app, you will get a close Pokedex view. Press the Pokedex button to open the tiles.",
          `• After opening the tiles you will get a list full of Pokémon's. You can click on a Pokémon card and a new screen will appear with the Pokémon's details and the Pokedex will read for you the description of the Pokémon.`,
          "• You can search for a Pokémon name or ID.",
        ]);
        break;

      case 6:
        setSlides([PttCanvas, Ptt1, Ptt2, Ptt3]);
        setTitle("PTT-WebSocket");
        setSubtitle("A real-time communication PTT system.");
        setDescription([
          "• This project is part of a big project which enable dispatchers and users to communicate with each other in real-time.",
          "• This project has three parts, the first part is an application for the Android PTT device, the second part is a website for the dispatchers and the third part is a Back-end which includes a websocket and an API calls.",
          "• The reason of using WebSocket in this project is the advantage of communicating in real-time.",
          "• This system was developed by me independently for a little over a year and is currently in the testing phase and will go into production soon.",
          "• Wish me luck!",
        ]);
        break;

      default:
        setSlides([]);
    }

    setIsPopupOpen(true);
  };

  return (
    <section className="Projects" id="Projects">
      <h2 className="Projects__title">What I've been working on</h2>
      <p className="Projects__text">
        I like to stay busy and always have a project in the works. <br /> Take
        a look at some of my applications I've dedicated my time to.
      </p>

      <ul className="Projects__list">
        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">Beled</h3>
            <h4 className="Projects__item-text">
              From China to your doorstep, Beled bridges the gap. <br /> Your
              trusted trading partner, simplifying sourcing and delivering
              success.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(1)}>
              Read more ›
            </p>
            <a
              className="Projects__item-link"
              href="https://beledglobal.com"
              target="_blank"
              rel="noreferrer"
            >
              View Website ›
            </a>
          </div>
          <img
            className="Projects__item-image"
            src={beled_colage}
            alt="Beled"
            onClick={() => openPopup(1)}
          />
        </li>

        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">Hasharon-laundry</h3>
            <h4 className="Projects__item-text">
              Self-service laundry services.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(2)}>
              Read more ›
            </p>
            <a
              className="Projects__item-link"
              href="https://hasharon-laundry.co.il"
              target="_blank"
              rel="noreferrer"
            >
              View Website ›
            </a>
          </div>
          <img
            className="Projects__item-image"
            src={laundry_colage}
            alt="Beled"
            onClick={() => openPopup(2)}
          />
        </li>

        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">News‑explorer</h3>
            <h4 className="Projects__item-text">
              Search and reveal the latest worldwide news.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(3)}>
              Read more ›
            </p>
            <a
              className="Projects__item-link"
              href="https://github.com/roeilulavy/news-explorer-frontend"
              target="_blank"
              rel="noreferrer"
            >
              View repository ›
            </a>
          </div>
          <img
            className="Projects__item-image"
            src={news_colage}
            alt="News"
            onClick={() => openPopup(3)}
          />
        </li>

        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">Around The U.S </h3>
            <h4 className="Projects__item-text">
              A social photos sharing website.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(4)}>
              Read more ›
            </p>
            <a
              className="Projects__item-link"
              href="https://github.com/roeilulavy/around-react"
              target="_blank"
              rel="noreferrer"
            >
              View repository ›
            </a>
          </div>
          <img
            className="Projects__item-image"
            src={around_colage}
            alt="Around the U.S"
            onClick={() => openPopup(4)}
          />
        </li>

        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">Pokedex</h3>
            <h4 className="Projects__item-text">
              Explore and learn about variant of Pokemons.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(5)}>
              Read more ›
            </p>
            <a
              className="Projects__item-link"
              href="https://github.com/roeilulavy/react-pokedex"
              target="_blank"
              rel="noreferrer"
            >
              View repository ›
            </a>
            <a
              className="Projects__item-link"
              href="https://roeilulavy.github.io/react-pokedex/"
              target="_blank"
              rel="noreferrer"
            >
              View Website ›
            </a>
          </div>
          <img
            className="Projects__item-image"
            src={pokedex_colage}
            alt="Pokedex"
            onClick={() => openPopup(5)}
          />
        </li>

        <li className="Projects__item">
          <div className="Projects__item-description">
            <h3 className="Projects__item-title">PTT-Websocket</h3>
            <h4 className="Projects__item-text">
              A real-time communication PTT App & Website.
            </h4>
            <p className="Projects__item-link" onClick={() => openPopup(6)}>
              Read more ›
            </p>
          </div>
          <img
            className="Projects__item-image"
            src={ptt_colage}
            alt="PTT"
            onClick={() => openPopup(6)}
          />
        </li>
      </ul>

      <ImageSlider
        slides={slides}
        title={title}
        subtitle={subtitle}
        description={description}
        isPopupOpen={isPopupOpen}
        setIsPopupOpen={setIsPopupOpen}
      />
    </section>
  );
}
